import {DeleteOutlined, FilterOutlined, PlusOutlined, ThunderboltOutlined, ZoomInOutlined} from "@ant-design/icons";
import {Button, DatePicker, Drawer, Modal, Popconfirm, Radio, Select, Table, Tabs, message, Form} from 'antd';
import React, {useEffect, useState} from "react";
import i18next from "i18next";
import {ZoomIn} from "../management/utils/ZoomIn";
import {Flash} from "../management/utils/Flash";
import Input from "antd/es/input/Input";
import {useForm} from "antd/lib/form/Form";
import {format} from 'date-fns';
import {options1, options2} from "../../../../utilities/ConditionOperators";
import {ConditionsSwitch} from "../management/utils/ConditionsSwitch";


const MapToolInfoFilterComponent = ({mapDiv, mapView, mapConfig}) => {

    const [sublayers, setSublayers] = useState();
    const [selectedValue, setSelectedValue] = useState();//selected layer in filter
    const [selectedDate, setSelectedDate] = useState();//selected date in filter rule
    const [valueType, setValueType] = useState();//input is date, number or string
    const [selectableFields, setSelectableFields] = useState();//columns from selected sublayer

    const [availableConditions, setAvailableConditions] = useState();

    const [form] = useForm()

    const [visibleForm, setVisibleForm] = useState(false);

    const [open, setOpen] = useState(false);
    const [columnsNames, setColumnsNames] = useState();
    const [data, setData] = useState(false);

    const onClose = () => {
        setOpen(false);
    };

    let selectArray = []

    useEffect(() => {

        let k = 0
        for (var i = 0; i < mapView.map.layers.items.length; i++) {

            for (var j = 0; j < mapView.map.layers.items[i].sublayers.length; j++) {
                selectArray[k] = {
                    value: k,
                    label: mapView.map.layers.items[i].sublayers.getItemAt(j).title,
                    layerId: i,
                    subLayerId: j
                }
                k = k + 1
            }
        }
        //console.log(selectArray)
        setSublayers(selectArray)
    }, [])

    function zoom(geometry, geometryType) {
        ZoomIn(geometry, geometryType, mapView)
    }

    function flash(geometry, geometryType) {
        Flash(geometry, geometryType, mapView)
    }

    function getLayerfeatures() {
        //console.log("form is ", form.getFieldsValue())

        let selectedFieldName
        let condition
        let value
        if (form != undefined) {

            selectedFieldName = form.getFieldsValue().selectedFieldName
            condition = form.getFieldsValue().condition
            value = form.getFieldsValue().enteredValue
        }
        setOpen(true)

        if (selectedValue == undefined) {
            return "Please select sublayer"
        }
        //console.log("selected value is", selectedValue)

        const sublayer = mapView.map.layers.items[selectedValue.layerId].sublayers.getItemAt(selectedValue.subLayerId);

        const query = sublayer.createQuery();
        query.outFields = ["*"];
        query.returnGeometry = true;

        sublayer.queryFeatures(query).then((result) => {

            if (result.features.length > 0) {

                const fieldNames = Object.keys(result.features[0].attributes);

                //console.log("filed name are", fieldNames)
                const rows = result.features.map((feature) => {
                    const attributes = feature.attributes;
                    const geometry = feature.geometry;
                    const geometryType = feature.geometry.type;
                    const row = {};
                    fieldNames.forEach((fieldName) => {

                        row[fieldName] = attributes[fieldName];
                        row["geo"] = geometry
                        row["geoType"] = geometryType

                        //check of there is a rule
                        if (selectedFieldName == undefined) {
                            row["isActive"] = true
                        }

                        //this is for date
                        if (fieldName.toLowerCase().includes("fecha")) {
                            let date = new Date(attributes[fieldName]);
                            let temp = date.setHours(0, 0, 0, 0)
                            const formattedDate = format(date, 'dd/MM/yyyy');
                            row[fieldName] = formattedDate
                            if (value) {
                                ConditionsSwitch(condition, temp, selectedDate, row)
                            }
                        } else if (fieldName === selectedFieldName) {
                            let temp = attributes[fieldName]
                            ConditionsSwitch(condition, temp, value, row)
                        }
                    });
                    return row;
                })
                setData(rows);

                const filteredRows = rows.filter((row) => row["isActive"] === true);

                const dataWithButtons = filteredRows.map((row) => ({
                    zoom: <Button onClick={() => {
                        zoom(row.geo, row.geoType)
                    }} type="primary" id="table-buttons" ghost><ZoomInOutlined/></Button>,
                    flash: <Button onClick={() => {
                        flash(row.geo, row.geoType)
                    }} type="primary" id="table-buttons" ghost><ThunderboltOutlined/></Button>,
                    ...row
                }));
                setData(dataWithButtons);

                const columns = [
                    {
                        title: "Zoom",
                        key: "zoom",
                        dataIndex: "zoom"
                    },
                    {
                        title: "Flash",
                        key: "flash",
                        dataIndex: "flash"
                    },
                    ...fieldNames.map((fieldName) => ({
                        title: fieldName,
                        dataIndex: fieldName,
                        key: fieldName
                    }))
                ];
                setColumnsNames(columns);
            } else {
                setData([]);
            }
        }).catch((error) => {
            console.error(error);
        });
    }

    function handleChange(value, option) {
        let pair = {
            layerId: option.label.layerId,
            subLayerId: option.label.subLayerId
        }
        setSelectedValue(pair)
    }

    const onChange = (date, dateString) => {
        //console.log(date, dateString);
        let dateT = new Date(date)
        dateT.setHours(0, 0, 0, 0)
        setSelectedDate(dateT.getTime())
    };

    function addFilterRule() {
        const sublayer = mapView.map.layers.items[selectedValue.layerId].sublayers.getItemAt(selectedValue.subLayerId);
        const query = sublayer.createQuery();
        query.outFields = ["*"];
        query.returnGeometry = true;

        let options = []
        sublayer.queryFeatures(query).then((result) => {
            if (result.features.length > 0) {
                const fieldNames = Object.keys(result.features[0].attributes);
                //console.log("filed name are", fieldNames)
                for (let i = 0; i < fieldNames.length; i++) {
                    options[i] = {
                        value: fieldNames[i],
                        label: fieldNames[i],
                    }
                }
                setSelectableFields(options)
            }
        })
        setVisibleForm(true)
    }

    function clearRules() {
        setSelectableFields(undefined)
        setVisibleForm(false)
        setValueType(undefined)
        setSelectedDate(undefined)
        form.resetFields()
    }

    function getFieldType(value) {
        //console.log("select option is", value)
        if (value != undefined && value != null) {
            if (value.toLowerCase().includes("fecha")) {
                form.resetFields(['enteredValue'])
                setValueType("date")
                setAvailableConditions(options1)
            } else if (value.toLowerCase().includes("objectid")) {
                setValueType("number")
                setSelectedDate(undefined)
                form.resetFields(['enteredValue'])
                setAvailableConditions(options1)
            } else {
                setSelectedDate(undefined)
                setValueType(undefined)
                form.resetFields(['enteredValue'])
                setAvailableConditions(options2)
            }
        }
    }

    function render() {
        if (sublayers != undefined) {
            return (
                <>
                    <br/>
                    <div>
                        <Select
                            rules={[{required: true, message: 'Please select sublayer'}]}
                            allowClear
                            placeholder="Select sublayer"
                            style={{width: 300}}
                            onChange={handleChange}
                            groupby="layerId"
                        >
                            {sublayers.map(option => (
                                <Select.Option key={option.value} value={option.value} label={option}>
                                    {option.label}
                                </Select.Option>
                            ))}
                        </Select>
                        <br/>
                        <br/>
                        <Button type="reset" onClick={addFilterRule}
                                disabled={selectedValue === undefined}><PlusOutlined/></Button>

                        <Button type="reset" onClick={clearRules}
                                disabled={selectableFields === undefined}><DeleteOutlined/></Button>
                        <br/>
                        <p></p>

                        {visibleForm && (
                            <Form form={form} style={{width: 280}} layout="vertical">
                                <Form.Item name="selectedFieldName" label="Select a field" rules={[{required: true}]}>
                                    <Select options={selectableFields}
                                            allowClear
                                            style={{width: 180}}
                                            placeholder={"Select Field"}
                                            id="clear"
                                            onChange={getFieldType}
                                    />

                                </Form.Item>
                                <Form.Item name="condition" label="Select condition" rules={[{required: true}]}>
                                    <Select
                                        placeholder={"Select condition"}
                                        style={{
                                            width: 180,
                                        }}
                                        options={availableConditions}
                                    />
                                </Form.Item>
                                <Form.Item name="enteredValue" label="Enter value" rules={[{required: true}]}>
                                    {valueType === 'date' ? (
                                        <DatePicker onChange={onChange} format="DD/MM/YYYY"/>
                                    ) : valueType === 'number' ? (
                                        <Input style={{width: 180}} type={"number"}/>
                                    ) : (
                                        <Input style={{width: 180}}/>
                                    )}
                                </Form.Item>
                            </Form>
                        )}
                        <Button type="reset" onClick={getLayerfeatures} disabled={selectedValue === undefined}
                                style={{border: '1px solid black', float: "right"}}><FilterOutlined/></Button>
                    </div>
                    <br/>
                </>
            );
        }
    }

    return (
        <>
            <Drawer title="Filter Table" mask={false}
                    placement="right" /*placement="bottom"*/
                    onClose={onClose} open={open}>
                <>
                    <div style={{userSelect: 'text'}}>
                        <Table columns={columnsNames} dataSource={data} rowKey="OBJECTID"/>
                    </div>
                </>
            </Drawer>
            {render()}
        </>
    );
}

export default MapToolInfoFilterComponent;